module.exports = __webpack_public_path__ + "static/Muli-Regular-faabc1cd33748bdbde66860d54f88398.woff2";